import FormFieldProps, {
    FormFields,
    FormFieldType,
    isFormFieldProp,
    isFormFields,
} from '@App/forms/v2/common/form-field'
import { ZodObject, ZodRawShape, ZodTypeAny } from 'zod'

const populateSchema = <T, Z extends ZodRawShape>(
    formFields: FormFieldType<T>,
    schema: ZodObject<Z>
): FormFields<T> => {
    if (formFields && isFormFields(formFields)) {
        Object.entries(formFields).forEach((entry) => {
            const formFieldValue = entry[1] as FormFieldType<T>
            if (isFormFieldProp(formFieldValue)) {
                const fieldProp = formFieldValue as FormFieldProps
                fieldProp.schema = schema.shape[entry[0]] as ZodTypeAny
            }
        })
        return formFields
    } else {
        throw new Error('Unable To Process - Not FormFields')
    }
}
export default populateSchema
